/* PrivateRoute component definition */
// import {PrivateRoute} from '../../components/PrivateRoute' import

import { PrivateRoute, PublicRoute } from "react-router-with-props";
import React, { Component, Fragment } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { compose, graphql } from "react-apollo";

import About from "../../components/About";
// import AccountProvider from "../../providers/AccountProvider";
import ChangePassword from "../../components/ChangePassword.jsx";
import Pages from "../../containers/Pages/Pages.jsx";
import Queries from "../../queries/queries2";
import RootProvider from "../../providers/RootProvider";
import Spinner from "../../elements/Spinner/Spinner";
import protectedRoutes from "../../routes/app.jsx";
import querySearch from "stringquery";

//import Dash from '../../containers/Dash/Dash.jsx';

// dynamically create app routes import appRoutes from "../../routes/app.jsx";
//import publicRoutes from "../../routes/pages.jsx";

//import gql from "graphql-tag";

//import CompanyList from '../../components/CompanyList'
// const PrivateRoute = ({   component: Component,   ...rest }) => (   <Route
// {...rest}     render={props => (props.authed     ? (<Component {...props}/>)
//   : (<Redirect       to={{       pathname: '/pages/login-page', state: {
// from: props.location       }     }}/>))}/> )

// const Listcompanies = () => {
//   return (
//       <div>List COMPANIES MOCK</div>

//   );
// }

class App extends Component {
  state = {};

  // _logout = () => {   // remove token from local storage and reload page to
  // reset apollo client   localStorage.removeItem("graphcoolToken");
  // window.location.reload(); }; _showLogin = () => {
  // this.props.history.replace("/pages/login-page"); }; _showSignup = () => {
  // this.props.history.replace("/signup"); };

  _isLoggedIn = () => {
    const token = localStorage.getItem("graphcoolToken");
    // console.log("_isLoggedIn token", token, this.props.loggedInUserQuery);
    // console.log('_isLoggedIn', this.props.loggedInUserQuery);

    const logged =
      this.props.loggedInUserQuery.loggedInUser &&
      !this.props.loggedInUserQuery.loggedInUser.loading &&
      this.props.loggedInUserQuery.loggedInUser.id !== null &&
      // token!
      token !== null &&
      token !== "";
    return logged;
  };

  componentDidUpdate(e) {
    const qsParams = querySearch(
      // encodeURI(
      this.props.location.search
    );
    // )
    // console.log("App.componentDidUpdate", this.state, this.props);
    if (qsParams.email) {
      // force new login
      localStorage.removeItem("graphcoolToken");
    }

    // if (   window.innerWidth < 993 &&   e.history.action === "PUSH" &&
    // document.documentElement.className.indexOf("nav-open") !== -1 ) {
    // document.documentElement.classList.toggle("nav-open"); }
  }

  render() {
    // console.log("render App");
    const companyId = sessionStorage.getItem("companyId");
    const userTiersId = sessionStorage.getItem("userTiersId");
    const role = sessionStorage.getItem("role");
    const loggedEmail = sessionStorage.getItem("loggedEmail");
    const companyOptions = sessionStorage.getItem("companyOptions");
    
    // console.log("App.render");
    // console.log("loading companyId", companyId);
    // console.log("load userTiersId", userTiersId);
    // console.log("load role", role);
    if (this.props.loggedInUserQuery.loading) {
      return <Spinner size="lg" fullScreen />;
    }

    const isLoggedIn = this._isLoggedIn();
    // console.log("99 - this.props", this.props););

    return (
      // <React.StrictMode>
      <RootProvider
        companyId={companyId}
        userTiersId={userTiersId}
        role={role}        
        loggedEmail={loggedEmail}

      // getCompanyInfoForContainer={this.props.getCompanyInfoForContainer}
      >
        {/* <AccountProvider> */}
        <Fragment>
          <Switch>
            <Route path="/about" component={About} />
            <Route path="/resetpassword" component={ChangePassword} />

            {/* <Route path='/companies' component={CompanyList}/> */}
            <PublicRoute
              path="/pages/login-page"
              authed={isLoggedIn}
              redirectTo="/companies"
              component={Pages}
            />

            <PublicRoute
              path="/pages/register-page"
              authed={isLoggedIn}
              redirectTo="/companies"
              component={Pages}
            />

            {/* <PublicRoute
            path="/pages/resetpassword-page"
            authed={isLoggedIn}
            redirectTo="/login-page"
            component={Pages}
          /> */}

            {protectedRoutes.map((prop, key) => {
              return (
                <PrivateRoute
                  path={prop.path}
                  authed={isLoggedIn}
                  redirectTo="/pages/login-page"
                  component={prop.component}
                  userId={
                    this.props.loggedInUserQuery.loggedInUser &&
                    this.props.loggedInUserQuery.loggedInUser.id
                  }
                  companyId={companyId}
                  userTiersId={userTiersId}
                  role={role}
                  key={key}
                  companyOptions={companyOptions}
                  loggedEmail={loggedEmail}
                />
              );
            })}
          </Switch>
        </Fragment>
        {/* // </React.StrictMode> */}
        {/* </AccountProvider> */}
      </RootProvider>
    );
  }
}

export default compose(
  graphql(Queries.LoggedInUserQuery, {
    name: "loggedInUserQuery",
    options: {
      fetchPolicy: "network-only"
    }
  })
  // graphql(Queries.getCompanyInfoForContainer, {
  //   name: "getCompanyInfoForContainer"
  // })
)(withRouter(App));
